import SimpleLightbox from "simplelightbox";


export class SingleCar {
  constructor() {
    if (!document.querySelector('.s-single-car')) return
    this.initLightbox()
    this.initTabs()
  }

  initLightbox() {
    const galleries = document.querySelectorAll('[data-lightbox="car-images"]')
    galleries.forEach((el) => {
      const links = el.querySelectorAll('a[href]')
      if (links.length) {
        new SimpleLightbox(Array.from(links), {
          captions: false,
          showCounter: true,
        })
      }
    })
  }

  initTabs() {
    const navItems = document.querySelectorAll('.car-tabs-nav-item');
    const panels = document.querySelectorAll('.car-tab-panel');
    console.log(navItems, panels);
    navItems.forEach(item => {
      item.addEventListener('click', function () {
        const target = this.getAttribute('data-tab');
        navItems.forEach(i => i.classList.remove('active'));
        panels.forEach(p => p.classList.remove('active'));
        this.classList.add('active');
        document.getElementById('tab-' + target).classList.add('active');
      });
    });
  }
}
